export const AUTH_PROVIDER_PROPS = {
  authority: process.env.REACT_APP_AUTH_BASE_URL,
  client_id: process.env.REACT_APP_AUTH_KEY,
  client_secret: process.env.REACT_APP_BASE_SECRET,
  redirect_uri: process.env.REACT_APP_BASE_URL,
  response_type: "token",
  scope: "profile_email",
  entity_id: process.env.REACT_APP_ENTITY_ID,
  metadata: {
    authorization_endpoint: `${process.env.REACT_APP_AUTH_BASE_URL}/authorize`,
    token_endpoint: `${process.env.REACT_APP_AUTH_BASE_URL}/token`,
    userinfo_endpoint: `${process.env.REACT_APP_AUTH_BASE_URL}/userinfo`,
    end_session_endpoint: `${process.env.REACT_APP_BASE_URL}`,
  },
  loadUserInfo: false,
  autoSignIn: false,
  extraQueryParams: {
    login_method: "sso",
    npa_user: process.env.REACT_APP_NPA_USER,
    npa_password: process.env.REACT_APP_NPA_PASSWORD,
  },
};
